import type { SettingsInput, TenantSettings } from '@provalia/shared';
import { SettingsForm } from '../../../shared/SettingsForm';
import { api, tenantPath } from '../../api';
import type { TenantTabProps } from '../TenantDetail';

export function SettingsTab({ slug, reload }: TenantTabProps): JSX.Element {
  const base = `${tenantPath(slug)}/settings`;
  return (
    <SettingsForm
      key={slug}
      load={() => api.get<{ settings: TenantSettings; defaults: TenantSettings }>(base)}
      save={async (input: SettingsInput) => {
        const res = await api.put<{ settings: TenantSettings }>(base, input);
        // SMTP y planos cuentan en la puesta en marcha.
        void reload();
        return res;
      }}
      testEmail={(to) => api.post(`${base}/test-email`, { to })}
    />
  );
}
